import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Text from "./Text";
import Check from "./CustomIcons/check";
import Uncheck from "./CustomIcons/uncheck";
import Visa from "./CustomIcons/visa";
import MasterCard from "./CustomIcons/mastercard";

const OptionSelector = styled.div`
  &:hover .payment-option-selector {
    border: solid 1px #b1aeba;
  }

  margin-bottom: 16px;
  > * {
    margin-bottom: 16px;
  }
  :last-child {
    margin-bottom: 0;
  }
  .payment-option-selector:last-of-type {
    margin-right: 0;
  }

  .payment-option-selector {
    min-height: 62px;
    box-sizing: border-box;
    border-radius: 8px;
    padding: 16px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    border: solid 1px #e8e8e8;
    color: #1c1c1c;
    background-color: #ffffff;
    width: 100%;
    &.selected {
      border: solid 2px #00c2a3;
      padding: 15px;
    }
    &.isNotInteractive {
      cursor: default;
    }
    .payment-option-selector-content {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .payment-option-selector-content-info {
        flex: 1;
        display: flex;
        align-items: center;

        .provider-logo {
          margin-right: 16px;
          width: 36px;
          height: 24px;
          svg {
            width: 100%;
            height: 100%;
          }
          @media (max-width: 374px) {
            width: 40px;
            height: 22px;
            margin-right: 8px;
          }
        }

        .providers-logo {
          display: flex;
          justify-content: flex-end;
          margin-left: auto;
          margin-right: 8px;
          gap: 4px;
          width: 70px;
          height: 20px;
          svg {
            width: 100%;
            height: 100%;
          }
        }
      }

      .payment-option-selector-content-subtitle {
        margin-top: 8px;
        flex-basis: 100%;
      }

      .payment-option-selector-checkbox {
        width: 24px;
        height: 24px;
      }
    }
  }
`;

const PaymentOptionSelector = ({
  product,
  title,
  subtitle,
  onClick,
  selected,
  isInteractive,
}) => {
  return (
    <OptionSelector>
      <div
        key={`payment-method-${product}`}
        className={`payment-option-selector${selected ? " selected" : ""}${
          !isInteractive ? " isNotInteractive" : ""
        }`}
        onClick={(event) => isInteractive && onClick(event)}
        onKeyPress={(event) => isInteractive && onClick(event)}
        role="button"
        tabIndex={0}
        data-testid="payment-option-selector"
      >
        <div className="payment-option-selector-content">
          <div className="payment-option-selector-content-info">
            <Text variant="body">{title}</Text>
            {product === "fp1" && (
              <div className="providers-logo">
                <Visa />
                <MasterCard />
              </div>
            )}
          </div>
          {isInteractive && (
            <div className="payment-option-selector-checkbox">
              {selected ? <Check /> : <Uncheck />}
            </div>
          )}

          {subtitle && (
            <div className="payment-option-selector-content-subtitle">
              <Text variant="body" secondary body2>
                {subtitle}
              </Text>
            </div>
          )}
        </div>
      </div>
    </OptionSelector>
  );
};

PaymentOptionSelector.propTypes = {
  product: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  isInteractive: PropTypes.bool,
};

PaymentOptionSelector.defaultProps = {
  subtitle: null,
  onClick: () => {},
  selected: false,
  isInteractive: true,
};

export default PaymentOptionSelector;
